module.exports = __webpack_public_path__ + "static/assets/5fe00313bc2f246caa98b0bfd62b0581.png";